<template>
  <div>
    <el-card style="padding-left: 20px;padding-right: 20px;margin-bottom: 5px">
      <el-form ref="newsForm" :model="newsForm">
        <el-form-item label="报告标题">
          <el-input
            v-model="newsForm.newsTitle"
            style="width:80%"
            :disabled="!isEdit"
          ></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="8">
            <el-form-item label="作者名称">
              <el-input
                style="width: 200px"
                placeholder="输入作者名称"
                v-model="newsForm.author"
                :disabled="!isEdit"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8"> </el-col>
          <el-col :span="8">
            <el-form-item label="访问人数">
              <el-input-number
                v-model="newsForm.visitNum"
                :disabled="!isEdit"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <label>正文</label>
          <editor :value="newsForm.content" @getValue="getContent"> </editor>
        </el-form-item>
        <el-form-item>
          <template>
            <!-- <el-button
              type="info"
              style="float: right;margin-left: 5px"
              @click="isEdit = !isEdit"
              >编辑</el-button
            > -->
            <el-button type="success" style="float: right;" @click="submitData"
              >确认</el-button
            >
          </template>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
const defaultForm = {
  id: undefined,
  newsTitle: "",
  author: "",
  // url: "",
  visitNum: "",
  // keywords: "",
  // description: "",
  content: "",
  // newsClassId: ""
  informationType: "",
  informationId: ""
};
import Editor from "../../components/Layout/editorInformation.vue";
import Upload from "../../components/Layout/Upload.vue";
import NewsClass from "../../api/newsClass.js";
import News from "../../api/news.js";
export default {
  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  name: "NewsDetail",
  data() {
    return {
      informationId: "",
      keywordsInputVisible: false,
      newsForm: {
        informationType: ""
      },
      newsClassOption: [],
      keywordsTags: [],
      inputKeywordsValue: ""
    };
  },
  methods: {
    // 信息公开查看
    async viewInfo() {
      // console.log(this.newsForm, "this.newsForm");
      let res = await News.queryInfomationDetails(this.newsForm);
      this.newsForm = res.msg;
      console.log(res.msg, "res");
    },
    getContent(val) {
      // console.log(val, "99999999999999999");
      this.newsForm.content = val;
    },
    showKeywordsInput() {
      this.keywordsInputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveKeywordsTagInput.$refs.input.focus();
      });
    },
    handleKeywordsClose(tag) {
      this.keywordsTags.splice(this.keywordsTags.indexOf(tag), 1);
    },
    handleKeywordsInputConfirm() {
      let inputKeywordsValue = this.inputKeywordsValue;
      if (inputKeywordsValue) {
        this.keywordsTags.push(inputKeywordsValue);
      }
      this.keywordsInputVisible = false;
      this.inputKeywordsValue = "";
      console.log("keywordsTags:", this.keywordsTags);
    },
    async getNewsClassOption() {
      this.newsClassOption = await NewsClass.getList();
    },
    // async getNews(data) {
    //   let res = await News.get(data);
    //   if (res.code === 0) {
    //     this.newsForm = res.msg;
    //     this.keywordsTags = this.newsForm.keywords.split("&");
    //   } else {
    //     this.$message.error(res.msg);
    //   }
    // },
    async submitData() {
      let ppp = JSON.parse(JSON.stringify(this.newsForm));
      console.log(ppp, "this.newsForm");
      this.newsForm.content = sessionStorage.getItem("valEditor");
      let res = await News.saveInformation(this.newsForm);
      // console.log(res, "信息公开--");
      if (res.code === 1) {
        this.$notify.success(res.msg);
        if (this.$route.query.type == 1) {
          this.$router.push("/news/listAudit");
        } else {
          this.$router.push("/news/listYearly");
        }
      } else {
        this.$notify.error(res.msg);
      }
    }
  },
  components: {
    Editor,
    Upload
  },
  watch: {
    keywordsTags: function(val) {
      this.newsForm.keywords = "";
      val.forEach(v => {
        this.newsForm.keywords += "&" + v;
      });
      this.newsForm.keywords = this.newsForm.keywords.substr(
        1,
        this.newsForm.keywords.length + 1
      );
    },
    newsForm: {
      handler(val) {
        // console.log(val, "0-0-0-0-0");
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.newsForm.newsTitle='';
    this.newsForm.author='';
    this.newsForm.visitNum='';
    this.newsForm.content='';
    this.getNewsClassOption();
  },
  created() {
    let informationType = "";
    if (this.$route.query.type == 1) {
      informationType = 1;
    } else if (this.$route.query.type == 2) {
      informationType = 2;
      
    }
    if (this.$route.query.id) {
      this.newsForm.id = this.$route.query.id;
      this.viewInfo();
    } else {
      this.isEdit = true;
     this.newsForm = Object.assign(defaultForm, { informationType });
    }
    // this.informationId = this.$route.query.id;
    // console.log(this.$route.query.id, "this.$route.query");
    if (!this.isEdit) {
      const id = this.$route.params && this.$route.params.id;
      // this.getNews(id);
    } else {
    }
    // console.log(this.newsForm, "-=-=-=-=-=-=");
  }
};
</script>

<style scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// src/views/Information/add.vue